import { Controller } from "@hotwired/stimulus"
import * as Turbo from "@hotwired/turbo"

// Card #4871 (Inbox phase 1, part B). Mobile single-select standing in for
// the desktop Inbox tabs (Needs me / Following / Snoozed / Done) -- each
// <option> value is the full path for that view (filters preserved, see
// activities/_view_tabs.html.erb), so navigating is just a Turbo visit to
// whichever one was picked.
export default class extends Controller {
  navigate(event) {
    Turbo.visit(event.target.value)
  }
}
